let items = [
	{
		src: "assets/images/hotel1.jpeg",
		altText: "Hotel Taj",
		caption: "Hotel Taj",
	},
	{
		src: "assets/images/hotel2.jpg",
		altText: "Radisson Blue",
		caption: "Radisson Blue",
	},
	{
		src: "assets/images/hotel3.jpg",
		altText: "Country Inn",
		caption: "Country Inn",
	},
];

export default items;